<template>
  <div class="col-12 text-subtitle2 q-pt-none q-pb-sm">
    <div class="meta metaHeader q-pb-sm">
      <q-img
        :src="require(`@/assets/img/group-meta.svg`)"
        :alt="datos.imagen"
        height="30px"
        width="30px"
        contain
      />
      OBJETIVOS ESPECÍFICOS
    </div>
    <div
      v-for="(meta, i) in metas"
      v-bind:key="`meta-${meta.name}-${i}`"
      class="metas col-12"
    >
      <MetaItem
        :adminMode="adminMode"
        :idObjetivo="datos.id"
        :meta="meta"
        :metaPositionArray="i"
        :color="datos.color"
        :colorhover="datos.colorHover"
        :isSelected="meta .id === idObjetivoEspecificoSelected ||  idObjetivoEspecificoSelected === ''? false : true"
        @showActions="showActions"
        @openIndicadores="openIndicadores"
        data-cy="metaItem"
      />
      <ListadoAcciones v-if="meta.id === idObjetivoEspecificoSelected && showListadoAcciones" :acciones="acciones" :isLoading="isLoading" :visibleColumns="isCiudadano ? ['name', 'fase'] : ['name', 'fase','ver']" />
      <ListadoIndicadores v-if="meta.id === idObjetivoEspecificoSelected && showListadoAcciones && showIndicadores" v-model="showIndicadores" :indicadores="indicadores"/>
    </div>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import MetaItem from './MetaItem.vue';
import { QImg } from 'quasar';
import ListadoAcciones from '@/components/Aue/components/ListadoAcciones.vue';
import * as types from '@/storeModules/NGUD/types';
import { mapGetters } from 'vuex';
import ListadoIndicadores from '@/components/Indicadores/components/ListadoIndicadoresResponsive.vue';
import Loading from '@/components/shared/mixins/Loading.js';
import Vue from 'vue';
import Const from '@/components/shared/helpers/Const.js';

export default {
  mixins: [Message, Loading],
  computed: {
    ...mapGetters({
      isCiudadano: 'NGUD/isCiudadano',
      ciudadSelected: 'NGUD/ciudadData'
    })
  },
  components: {
    QImg,
    MetaItem,
    ListadoAcciones,
    ListadoIndicadores
  },
  props: {
    value: {
      required: true
    },
    objetivos: {
      required: true
    },
    adminMode: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      showIndicadores: false,
      datos: this.objetivos,
      metas: null,
      showListadoAcciones: false,
      acciones: [],
      isLoading: false,
      idObjetivoEspecificoSelected: '',
      isSelected: true,
      indicadores: [],
      arrayIndicadoresAdd: [],
      resolutionMobile: Const.RESOLUTION_MOBILE,
      objetivoEspecificoHeigth: 0
    };
  },
  methods: {
    openIndicadores (o) {
      if (this.resolutionMobile.matches) {
        this.$store.state.NGUD.Aue.selected = o.param;
        this.showLoading();
        this.arrayIndicadoresAdd = [];
        this.getDataTarjetaIndicadores(o).then(() => {
          o.done(true);
        });
      }
    },
    async showActions (idObjetivoEspecifico) {
      this.isLoading = true;
      await this.$store.dispatch(types.ACTION_GET_ACCIONES_OBJETIVO_ESPECIFICO, { idObjetivo: idObjetivoEspecifico.paramMeta }).then(async response => {
        this.idObjetivoEspecificoSelected = idObjetivoEspecifico.paramMeta;
        this.showListadoAcciones = true;
        this.acciones = response.data;
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
      idObjetivoEspecifico.done(true);
    },
    async getDataTarjetaIndicadores (o) {
      let arrayIndicadores = [];
      await this.$store.dispatch(types.ACTION_GET_INDICADORAUE_OBJETIVOESPECIFICO_TARJETASINDICADORESACCIONES, { idCiudad: this.ciudadSelected.id, idObjetivoEspecifico: o.param.metaId })
        .then(response => {
          arrayIndicadores = new Promise((resolve, reject) => {
            response.forEach(async (indicador) => {
              await this.fillIndicadores(indicador);
            });
            resolve(response);
          });
          arrayIndicadores.then((val) => {
            this.hideLoading();
            this.indicadores = [...val];
            if (this.indicadores.length > 0) {
              this.showIndicadores = true;
            } else {
              this.showIndicadores = false;
            }
          });
        }).catch(() => {
          this.hideLoading();
        });
    },
    async fillIndicadores (indicador) {
      if (indicador.tipo === 'Cualitativo' || indicador.tipo === 'Cuantitativo') {
        this.arrayIndicadoresAdd.push(indicador);
      } else {
        await this.getDataGraficaIndicador(indicador);
      }
      return this.arrayIndicadoresAdd;
    },
    async getDataGraficaIndicador (indicador) {
      await this.$store.dispatch(types.ACTION_GET_INDICADOR_TARJETA, { idCiudad: this.ciudadSelected.id, idIndicador: indicador.idIndicador })
        .then(response => {
          Vue.set(indicador, 'tarjeta', response);
          this.arrayIndicadoresAdd.push(indicador);
        }).catch(() => {
        });
    }
  },
  watch: {
    value: {
      handler: function (newValue) {
        this.metas = newValue.metas;
        this.idObjetivoEspecificoSelected = '';
      }
    },
    objetivos: {
      handler: function (newValue) {
        this.datos = newValue;
        this.idObjetivoEspecificoSelected = '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.meta{
  font-weight: bold;
}
.metas{
  .meta {
    align-items: center;
    display: flex;
    font-weight: bold;
    margin-bottom: 10px;
    min-height: 62px;
    padding: 10px 20px;
  }
}
@media (max-width: 640px) {
  .meta {
    font-size: 10px;
  }
  .metaHeader{
    font-size: 11px;
  }
  ::v-deep {
      .listadoAcciones{
        margin-left: 10px !important;
        margin-right: 10px !important;
      }
      .q-table__control {
        font-size: 11px !important;
        .q-field__control-container {
          font-size: 11px !important;
        }
      }
      .q-table {
          th{
            font-size: 11px !important;
          }
          tbody td{
            font-size: 11px !important;
          }
      }
      .q-chip{
        font-size: 11px;
        .q-avatar{
          height: 13px;
        }
      }
      .q-icon{
        font-size: 20px;
      }
      .titleDetalle {
        font-size: 11px !important;
      }
      .container-indicador {
        padding: 15px !important;
        height: auto !important;
      }
    }
}
</style>
